export function removaPagamentosComValorZero(pagamentos: any, formasDaEmpresa: any[] = []): any {
  if(!Array.isArray(pagamentos)) return pagamentos;

  // O arredondamento do desconto pode zerar centavos. No servidor, use as formas da empresa, nunca as do payload.
  if(pagamentos.length === 1 && formasDaEmpresa.some(forma =>
    Number(forma.id) === Number(pagamentos[0]?.formaDePagamento?.id) &&
    forma.possuiDesconto && forma.modoDesconto === 'PRODUTOS')) return pagamentos;

  return pagamentos.filter((pagamento: any) => {
    if(pagamento?.id != null) return true;

    const valor = pagamento?.valor;

    if(typeof valor === 'number') return valor !== 0;
    if(typeof valor !== 'string' || !valor.trim()) return true;

    const valorNumerico = Number(valor.trim().replace(',', '.'));

    return !Number.isFinite(valorNumerico) || valorNumerico !== 0;
  });
}
